module.exports = __webpack_public_path__ + "img/1528873843.8c382f81.jpg";